"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@airgram/core");
var components_1 = require("./components");
var Airgram = /** @class */ (function (_super) {
    __extends(Airgram, _super);
    function Airgram(config) {
        var _this = this;
        var instanceName = config.instanceName, isBackground = config.isBackground, jsLogVerbosityLevel = config.jsLogVerbosityLevel, logVerbosityLevel = config.logVerbosityLevel, mode = config.mode, readOnly = config.readOnly, useDatabase = config.useDatabase, restConfig = __rest(config, ["instanceName", "isBackground", "jsLogVerbosityLevel", "logVerbosityLevel", "mode", "readOnly", "useDatabase"]);
        var baseConfig = __assign({}, restConfig, { provider: new components_1.TdProvider({
                instanceName: instanceName,
                isBackground: isBackground,
                jsLogVerbosityLevel: jsLogVerbosityLevel,
                logVerbosityLevel: logVerbosityLevel,
                mode: mode,
                readOnly: readOnly,
                useDatabase: useDatabase
            }) });
        _this = _super.call(this, baseConfig) || this;
        return _this;
    }
    return Airgram;
}(core_1.Airgram));
exports.Airgram = Airgram;
